import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };

  // Defaults yield to explicit utilities in className, so call sites can pass
  // exact dimensions (h-5 w-5) or colors (text-white) without fighting
  // Tailwind's class-order resolution against the built-in defaults.
  const sizeClass = /(?:^|\s)[hw]-/.test(className) ? '' : (sizeClasses[size] || sizeClasses.md);
  const colorClass = /(?:^|\s)text-/.test(className) ? '' : 'text-primary';

  return (
    <div className={`${sizeClass} animate-spin ${colorClass} ${className}`}>      
      <svg className="h-full w-full" viewBox="0 0 24 24" fill="none">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner; 